import script from "./PanelOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./PanelOrders.vue?vue&type=script&setup=true&lang=js"

import "./PanelOrders.vue?vue&type=style&index=0&id=fcb81848&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fcb81848"]])

export default __exports__